import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApplicationRef, ChangeDetectorRef, inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { jkRestReturn, OpenWinLoadOption } from './jkInterface';
import { jkRestReturnClass, openWinClass } from './jkClass';
import { jkLib } from './jkCommon';
import { login, LoginService } from './jkUser';
//import { PageService } from './page.service';


@Injectable({
  providedIn: 'root',
})
export class OrmService {
  public http: HttpClient; // = inject(HttpClient);
  //public injector: Injector = inject(Injector);
  private _ip: string = '';
  appRef: ApplicationRef;
  constructor(
    //http: HttpClient,
  ) {
    //this.http = http;
    this.http = inject(HttpClient);
    this.appRef = inject(ApplicationRef);
    //console.log('OrmService before inject httpClient');
    //this.http = inject(HttpClient);
    // ATT:這裡不要再改了
    //this.http = injector.get(HttpClient);
    //this.getIp2();
  }
  init(http: HttpClient) {
    this.http = http;
  }
  checkInit() {
    if (!this.http) {
      //this.init(inject(HttpClient));
      const msg = 'XXX jkOrm http 未初始化';
      alert(msg);
      throw new Error(msg);
    }
  }
  ip(): string {
    if (this._ip !== '')
      return this._ip
    else {
      this.checkInit();
      this.get('https://api.ipify.org?format=json').subscribe((data) => {
        this._ip = data.ip;
        // console.log("Your IP is:", data.ip);
      });
      return this._ip;
    }
  }
  parseOpenwin(ret: jkRestReturn, owOpt: openWinClass) {
    let data = JSON.parse(ret.data);
    if (!owOpt.assign(data)) {
      //page.showAlert('error parseOpenwin:' + JSON.stringify(owOpt));
      alert('error parseOpenwin:' + JSON.stringify(owOpt));
    }

    return owOpt;
  }
  // 只取 sqlselect,sqlwhere,sqlorder,sqlreturn
  getopenwin(mainTable: string, item: string, type: string): Observable<any> {
    let mUrl = '/db/getopenwin';
    let urlParam = 'maintable=' + mainTable + '&type=' + type + '&item=' + item;
    let u = login.hostName + mUrl + '?' + urlParam;
    this.checkInit();
    return this.http.get<jkRestReturnClass>(u);
  }

  // type: W V S 比openwin_get 多自訂where order
  doOpenWinGet(
    host: string,
    type: string,
    maintable: string,
    item: string,
    where: string,
    order: string,
    param: string
  ) {
    let mUrl = '/db/openwin';
    let urlParam = '';
    urlParam = encodeURI(
      '?maintable=' +
      maintable +
      '&type=' +
      type +
      '&item=' +
      item +
      '&where=' +
      where +
      '&order=' +
      order +
      '&param=' +
      param
    );
    //const data = await jkLib.doFetch(Login.hostName, mUrl, urlParam, login.token, 'get');
    let u = host + mUrl + urlParam;
    this.checkInit();
    return this.http.get<jkRestReturnClass>(u);
  }
  doOpenWin(
    host: string,
    type: string,
    maintable: string,
    item: string,
    where: string,
    order: string,
    param: string | any[] | undefined | null
  ): Observable<any> {
    // use post
    let p: any[];
    if (typeof param === 'string') {
      p = param.split(',');
    } else if (Array.isArray(param)) {
      p = param;
    } else {
      p = param !== undefined && param !== null ? [param] : [];
    }
    let body = {
      mainTable: maintable,
      item: item,
      type: type,
      where: where,
      order: order,
      params: p,
    };
    let mUrl = '/db/openwin';
    //const data = await jkLib.doFetch(Login.hostName, mUrl, urlParam, login.token, 'get');
    let u = host + mUrl;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' }); // application/x-www-form-urlencoded
    this.checkInit();
    return this.http.post<jkRestReturnClass>(u, body, { headers: headers });
  }
  async doOpenWinAxios(
    host: string,
    type: string,
    maintable: string,
    item: string,
    where: string,
    order: string,
    param: string | any[],
    ret: jkRestReturn
  ): Promise<any> {
    // use post
    ret.clear();
    let paramList;
    if (typeof param === 'string') paramList = param.split(',');
    else paramList = param;
    let body = {
      mainTable: maintable,
      item: item,
      type: type,
      where: where,
      order: order,
      params: paramList,
    };
    let path = '/db/openwin';
    let method = 'post';
    //let ret:jkRestReturnClass = new jkRestReturnClass();
    try {
      let config = jkLib.axiosConfigInit(host, path, method, paramList, body);
      await jkLib.doAxios(config, ret);
      if (!ret.result) {
        console.error(
          'doOpenWinAxios error: ' + ret.errorLog + JSON.stringify(ret.obj)
        );
      }
      return ret.obj;
    } catch (error: any) {
      console.error('doOpenWinAxios error: ' + error.message);
      return null;
    }
  }
  query(sql: string, host?: string): Observable<any> {
    if (!host) host = login.hostName;
    return this.simpleSql(host, sql);
  }
  simpleSql(host: string, sql: string): Observable<any> {
    let body = { sql: sql };
    let mUrl = '/db/simplesql';
    let u = host + mUrl;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' }); // application/x-www-form-urlencoded
    this.checkInit();
    return this.http.post<jkRestReturnClass>(u, body, { headers: headers });
  }
  async simpleSqlPromise(
    host: string,
    sql: string,
    ret: jkRestReturn
  ): Promise<any> {
    ret.clear();
    let body = { sql: sql };
    let mUrl = '/db/simplesql';
    let u = host + mUrl;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' }); // application/x-www-form-urlencoded
    try {
      let config = jkLib.axiosConfigInit(host, mUrl, 'post', [], body);
      await jkLib.doAxios(config, ret);
      if (!ret.result) {
        let msg =
          'simpleSqlPromise error: ' + ret.errorLog + JSON.stringify(ret.obj);
        ret.addResultError(msg, true);
      }
      return ret.obj;
    } catch (error: any) {
      ret.addResultError('simpleSqlPromise error: ' + error.message, true);
      return null;
    }
  }
  doOpenWin_post(
    type: string,
    maintable: string,
    item: string,
    params: any[],
    where: string,
    order: string,
    host: string = login.hostName,
    token: string = login.token
    //expireDay: number = 0,// 0 永遠從server抓
    //openWin: IopenWin
  ): Observable<any> {
    let mUrl = '';
    mUrl = '/db/openwin';
    //let param = '';
    //param = JSON.stringify(params);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8',
      }),
    };
    /*if(type === 'W'){
      if(where.toUpperCase().indexOf('WHERE ')<0){
        where = ' WHERE 1=1 '+where ;
      };
    };*/
    let body = {
      mainTable: maintable,
      type: type,
      item: item,
      params: params,
      where: where,
      order: order,
    };
    this.checkInit();
    return this.http.post(host + mUrl, body, httpOptions);
  }
  doOpenwin(opt: OpenWinLoadOption): Observable<any> {
    let host = opt.host || login.hostName;
    let token = opt.token || login.token;
    return this.doOpenWin_post(
      opt.type,
      opt.mainTable,
      opt.item,
      opt.params,
      opt.where || '',
      opt.order || '',
      host,
      token
    );
  }
  doOpenwinLoad(opt: OpenWinLoadOption) {
    let host = opt.host || login.hostName;
    let token = opt.token || login.token;
    this.doOpenWin_post(
      opt.type,
      opt.mainTable,
      opt.item,
      opt.params,
      opt.where || '',
      opt.order || '',
      host,
      token
    ).subscribe((data) => {
      opt.list.push(...data.obj);
    });
  }
  doOpenwinLoadRx(opt: OpenWinLoadOption): Observable<any> {
    let host = opt.host || login.hostName;
    let token = opt.token || login.token;
    return this.doOpenWin_post(
      opt.type,
      opt.mainTable,
      opt.item,
      opt.params,
      opt.where || '',
      opt.order || '',
      host,
      token
    );
  }
  loadOpenwinOptions(opt: OpenWinLoadOption[]) {
    opt.forEach((o) => {
      this.doOpenwinLoad(o);
    });
  }
  /**
   * 參考 doOpenWinGet 多自訂where order

   * @param type
   * @param maintable
   * @param item
   * @param params
   * @param host
   * @param token
   * @returns
   */
  doOpenWin_get(
    type: string,
    maintable: string,
    item: string,
    params: any[],
    host: string = login.hostName,
    token: string = login.token
    //expireDay: number = 0,// 0 永遠從server抓
    //openWin: IopenWin
  ): Observable<any> {
    if (type === 'W') {
      alert('PR注意: doOpenWin_get type不可用W');
    }
    let mUrl = '';
    let urlParam = '';
    //mUrl = '/db/openwin_get';
    mUrl = '/db/openwin';
    let param = '';
    param = JSON.stringify(params);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' }); // application/x-www-form-urlencoded

    urlParam =
      'maintable=' +
      maintable +
      '&type=' +
      type +
      '&item=' +
      item +
      '&params=' +
      param;
    this.checkInit();
    return this.http.get(host + mUrl + '?' + urlParam, { headers: headers });
    /* if(!openWin){
      openWin = new openWinClass();
    }
    let b = true;
    if (expireDay > 0) {
      b = await this.isReload(type, maintable, item, expireDay);
    }
    if (!b) {
      let key = this.makeKey(type, maintable, item);
      let d = localStorage.getItem(key);
    } else {

      let mUrl = '';
      let urlParam = '';
      mUrl = '/db/openwin';
      let param = '';
      param = JSON.stringify(params);

      urlParam = 'maintable=' + maintable + '&type=' + type + '&item=' + item + '&params=' + param;
      const data = await jkLib.doFetch(Login.hostName, mUrl, urlParam, login.token, 'get');
      if (data.result) {
        openWin = JSON.parse(data.data);
        //jkLib.cloneObject(owOpt, openWin);
      } else {
        jkAlert(data.errorLog);
      }
      return data.obj;
    }*/
  }
  //   AdvCheck(Sender,'SYSUser','V01','UserName',VarArrayOf([Sender.AsString]),'E');
  async advCheck(
    item: any,
    maintable: string,
    itemId: string,
    returnFields: string,
    params: any[],
    alertType: string = 'E',
    host: string = login.hostName
  ): Promise<jkRestReturn> {
    //let paramStr = '';
    //paramStr = JSON.stringify(params);
    let ret = new jkRestReturnClass();
    let dataObj = await this.doOpenWinAxios(
      host,
      'V',
      maintable,
      itemId,
      '',
      '',
      params,
      ret
    );
    /*
    let o1 = JSON.parse(ret.data);
    let sqlReturn: string = o1.sqlReturn;
    sqlReturn = jkLib.swapStr(sqlReturn, '\r\n', '');
    let sqlReturnList = sqlReturn.split(',');

    if (Object.keys(dataObj).length === 0) {
      // {}
      ret.addResultError('advCheck error');
      return ret;
    }
    let retData0 = dataObj[0];
    if (!retData0) {
      ret.addResultError('代號錯誤或無回傳資料(advCheck)');
      return ret;
    }
    try {
      let returnList = returnFields.split(',');
      for (let i = 0; i < returnList.length; i++) {
        let f = returnList[i];
        if (f === '') continue;
        let keyField = sqlReturnList[i];
        let v = retData0[keyField];
        if (v === undefined) {
          ret.addResultError(maintable + '-' + itemId + ' 無回傳資料:' + f);
        } else item[f] = v;
      }
    } catch (error: any) {
      ret.addResultError(error.message);
      return ret;
    }*/
   this.advCheckParse(item, maintable, itemId, returnFields, ret);
    return ret;
  }
  private ensureRestReturn(ret: jkRestReturn): jkRestReturn {
    if (typeof ret.addResultError === 'function') {
      return ret;
    }

    Object.setPrototypeOf(ret, jkRestReturnClass.prototype);
    return ret;
  }

  advCheckParse(item: any, mainTable: string, itemId: string, returnFields: string, ret: jkRestReturn): jkRestReturn {
    ret = this.ensureRestReturn(ret);
    let o1 = JSON.parse(ret.data);
    let sqlReturn: string = o1.sqlReturn;
    let dataObj = ret.obj;
    sqlReturn = jkLib.clearCRLF(sqlReturn);
    let sqlReturnList = sqlReturn.split(',');

    if (Object.keys(dataObj).length === 0) {
      // {}
      ret.addResultError('advCheck 無符合條件資料.');
      return ret;
    }
    let retData0 = dataObj[0];
    if (!retData0) {
      ret.addResultError('代號錯誤或無回傳資料(advCheck)');
      return ret;
    }
    try {
      let returnList = returnFields.split(',');
      for (let i = 0; i < returnList.length; i++) {
        let f = returnList[i];
        if (f === '') continue;
        let keyField = sqlReturnList[i];
        let v = retData0[keyField];
        if (v === undefined) {
          ret.addResultError(mainTable + '-' + itemId + ' 無回傳資料:' + f);
        } else item[f] = v;
      }
      if(returnList.length > 0){
        // 延後到下一個 task：避免在事件處理 (e.g. blur) 觸發的 CD cycle 中
        // 同步改動已被綁定的欄位 (如 WB005)，導致 NG0100 ExpressionChangedAfterItHasBeenCheckedError
        //setTimeout(() => cdr.detectChanges());
        //cdr.markForCheck();  // 推薦預設選項
        setTimeout(() => this.appRef.tick(),2);  // 而不是 cdr.detectChanges()
      }
    } catch (error: any) {
      ret.addResultError(error.message);
      return ret;
    }
    return ret;

  }
  advCheckAsync(
    item: any,
    maintable: string,
    itemId: string,
    params: any[],
    host: string = login.hostName
  ): Observable<jkRestReturn> {
    const paramStr = params.join(',');
    return this.doOpenWin(
      host,
      'V',
      maintable,
      itemId,
      '',
      '',
      paramStr,
    );
  }
  /**
  * function TfrmBase.GetCheckData(xField: TField; xCheckName, xCheckType: string;
  xAllValues: Variant; var xOut: Variant): boolean;

  * @param item
  * @param maintable
  * @param itemId
  * @param params
  * @param host
  * @returns
  */

  async getCheckData(
    //item: any,
    maintable: string,
    itemId: string,
    params: any[],
    host: string = login.hostName
  ): Promise<jkRestReturn> {
    let ret = new jkRestReturnClass();
    let path = '/db/getCheckData';
    let method = 'post';
    let body = { mainTable: maintable, item: itemId, params: params };

    let config = jkLib.axiosConfigInit(host, path, method, params, body);
    await jkLib.doAxios(config, ret);
    return ret;
  }
  get(url: string): Observable<any> {
    this.checkInit();
    return this.http.get(url);
  }
  post(url: string, body: any): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' }); // application/x-www-form-urlencoded
    this.checkInit();
    return this.http.post(url, body, { headers: headers });
  }
  sendMail(body: any, ret: jkRestReturn): Observable<any> {
    let mUrl = '/uty/sendmail';
    let host = login.hostName;
    let u = host + mUrl;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' }); // application/x-www-form-urlencoded
    this.checkInit();
    return this.http.post<jkRestReturnClass>(u, body, { headers: headers });
  }
  async autoNo(type: string, table: string, keyFields: string, keyValues: string, date: string, padLength: number = 4): Promise<jkRestReturn> {
    let ret = new jkRestReturnClass();
    // http://localhost:9086/db/autono?type=detail&table=STKTQ&keyFields=TQ001,TQ002,TQ003&keyValues=20241027,F0200008728692&date=20241027
    let path = `/db/autono?type=${type}&table=${table}&keyFields=${keyFields}&keyValues=${keyValues}&date=${date}&padLength=${padLength}`;
    let method = 'get';
    let config = jkLib.axiosConfigInit(login.hostName, path, method, '', '');
    await jkLib.doAxios(config, ret);
    return ret;
  }
  autoNoAsync(type: string, table: string, keyFields: string, keyValues: string, date: string, padLength: number = 4): Observable<any> {
    let ret = new jkRestReturnClass();
    // http://localhost:9086/db/autono?type=detail&table=STKTQ&keyFields=TQ001,TQ002,TQ003&keyValues=20241027,F0200008728692&date=20241027
    let path = `/db/autono?type=${type}&table=${table}&keyFields=${keyFields}&keyValues=${keyValues}&date=${date}&padLength=${padLength}`;
    let method = 'get';
    let config = jkLib.axiosConfigInit(login.hostName, path, method, '', '');
    return this.http.get(login.host + path);

  }

  async xml2json(xml: string, ret: jkRestReturn) {
    let path = '/uty/xml2json';
    let base64 = Buffer.from(xml).toString('base64'); // base64 encode
    let body = { data: base64 };
    let config = jkLib.axiosConfigInit(login.hostName, path, 'post', [], body);
    try {
      await jkLib.doAxios(config, ret);
    } catch (error: any) {
      console.error('xml2json error: ' + error.message);
    }

  }
  async transactionSql(mSQLs: string[]): Promise<jkRestReturn> {
    const urlParam = '';
    const mReturn = await jkLib.doFetch(login.hostName, '/db/transactionsql', urlParam, login.token, 'post', mSQLs);

    return mReturn;
  };
  async transactionOneSql(mSQL: string): Promise<jkRestReturn> {
    // debugger;
    //let url = login.hostName + "/transactionsql";
    let mReturn: jkRestReturn = new jkRestReturnClass();
    const mSQLS: string[] = [];
    mSQLS.push(mSQL);
    mReturn = await this.transactionSql(mSQLS);
    return mReturn;
  };
  async getFrontConfig(configFileName: string, ret: jkRestReturn): Promise<any> {
    ret.clear();
    if (!configFileName) {
      ret.addResultError('environment.configFileName is required', true);
      return ret.obj;
    };
    let path = `/api/getFrontConfig?configFileName=${configFileName}`;
    let method = 'get';
    let config = jkLib.axiosConfigInit(login.hostName, path, method, '', '');
    await jkLib.doAxios(config, ret);
    if (!ret.result) {
      console.error('getFrontConfig:', ret.message);
    };
    return ret.obj;
  }

}
